import { useTranslation } from 'react-i18next'
import React from 'react'

import { useNavigation } from '../../../utils/contexts/NavigationContext'
import PageHeaderPanel from '../../../components/presentation/PageHeaderPanel'

const EditChecklistPage = ({ id }) => {
  const navigate = useNavigation()
  const { t } = useTranslation('editChecklist')

  const context = id > 0 && 'edit'
  const title = t('title', { context })

  return (
    <PageHeaderPanel
      leftIcon="BsArrowLeftShort"
      leftAction={() => navigate('/m/v2/checklists')}
      title={title}
      mediumPadding
      noContainer
    />
  )
}

export default EditChecklistPage
